import Marionette from 'backbone.marionette';
import { MatchCentre, MatchCentreLanding } from '../../views';
import { AdvertisingView } from '../../views';
import { Favourites, MatchStats } from '../../models'
import { Players, Positions, Rounds, Squads } from "../../collections";
import { Coach } from "../../models";
import { Model } from "backbone";
import { sizes_for_big_ad } from '../../../../core/utils';

export default class MatchCentreController extends Marionette.Object {
	matchCentreLanding(round_id) {
		const
			rootView = this.getOption('rootView'),
			matchCentreView = new MatchCentreLanding({
				round_id,
				rounds: new Rounds(),
				squads: new Squads()
			});

		rootView.getRegion('main').show(matchCentreView);
	}

	matchCentre(round_id, match_id) {
		const
			rootView = this.getOption('rootView'),
			matchCentreView = new MatchCentre({
				round_id, match_id,
				players: new Players(),
				rounds: new Rounds(),
				squads: new Squads(),
				positions: new Positions(),
				coach: new Coach(),
				stats: new MatchStats(),
				model: new Model(),
				favourites: new Favourites()
			}),
			advertisingHeader = new AdvertisingView({
				ad_id: 'div-gpt-ad-1607993787346-0',
				ad_path: 'match-centre',
				size: sizes_for_big_ad(),
				pos: 1,
			});

		matchCentreView.getRegion('ad_container').show(advertisingHeader);
		rootView.getRegion('main').show(matchCentreView);
	}
}